import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';
import PlaceSearchFormField from '../../normal/JsonPlaceSearchFormField';

const propTypes = {
  classes: PropTypes.shape({
    textLabel: PropTypes.string,
    textValue: PropTypes.string,
  }).isRequired,
  isEditing: PropTypes.bool.isRequired,
  initialValue: PropTypes.string,
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }).isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool,
    invalid: PropTypes.bool,
  }).isRequired,
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

const defaultProps = {
  initialValue: '',
};

const ViewableJsonPlaceSearchFormField = props => {
  const {
    classes,
    isEditing,
    initialValue,
    label,
    input: { value, onChange, onBlur, onFocus },
    meta: { error, touched, invalid },
    id,
    ...otherProps
  } = props;
  console.log('🚀 ~ file: index.js ~ line 43 ~ value', initialValue);

  const renderField = () => {
    if (isEditing) {
      return (
        <PlaceSearchFormField
          {...otherProps}
          initialValue={initialValue}
          label={label}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          errMsg={error}
          invalid={invalid}
          touched={touched}
          id={id}
        />
      );
    }

    return (
      <>
        <div className={classes.textLabel}>{label}</div>
        <div className={classes.textValue} id={`${id}-text-value`}>
          {initialValue}
        </div>
      </>
    );
  };

  return <div>{renderField()}</div>;
};

ViewableJsonPlaceSearchFormField.propTypes = propTypes;
ViewableJsonPlaceSearchFormField.defaultProps = defaultProps;

export default withStyles(styles)(ViewableJsonPlaceSearchFormField);
